module.exports = __webpack_public_path__ + "img/customer_4.920d308b.png";